function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'clotted-cream': 'rgb(245, 239, 233)','latte': 'rgb(167, 154, 137)','sage': 'rgb(90, 104, 89)','forest': 'rgb(34, 55, 49)','storm-cloud': 'rgb(24, 56, 72)','espresso': 'rgb(82, 61, 53)',};

    this.images = {'piano': 'url("//bumpyroadsstudio.com/cdn/shop/files/Piano_120x.jpg?2232")','forte': 'url("//bumpyroadsstudio.com/cdn/shop/files/Forte_120x.jpg?2232")','dandelion-seeds-on-espresso': 'url("//bumpyroadsstudio.com/cdn/shop/files/DandelionEspresso_120x.jpg?v=11821275650457921706")','dandelion-seeds-on-tan': 'url("//bumpyroadsstudio.com/cdn/shop/files/DandelionTan_120x.jpg?v=13418766313434850254")','dandelion-seeds-on-blue': 'url("//bumpyroadsstudio.com/cdn/shop/files/DandelionBlue_120x.jpg?v=1393199469638196424")','river-swirls-on-tan': 'url("//bumpyroadsstudio.com/cdn/shop/files/RiverSwrilsTan_120x.jpg?v=3963211638547008324")','river-swirls-on-espresso': 'url("//bumpyroadsstudio.com/cdn/shop/files/RiverSwrilsEspresso_120x.jpg?v=1043868486321007794")','daisy-field': 'url("//bumpyroadsstudio.com/cdn/shop/files/DaisyField_120x.jpg?v=13523683636975261495")','tansy-field': 'url("//bumpyroadsstudio.com/cdn/shop/files/TansyField_120x.jpg?v=3218440610279287810")','bunny-white-with-espresso-teal-thread': 'url("//bumpyroadsstudio.com/cdn/shop/files/BunnyWhiteEspressoTeal_120x.jpg?v=11829334326136102932")','oatmeal-with-clotted-cream-thread': 'url("//bumpyroadsstudio.com/cdn/shop/files/OatmealClottedCream_120x.jpg?v=10453078163321578322")','oatmeal-with-espresso-thread': 'url("//bumpyroadsstudio.com/cdn/shop/files/OatmealEspresso_120x.jpg?v=8928131127875897382")','oatmeal-with-teal-thread': 'url("//bumpyroadsstudio.com/cdn/shop/files/OatmealTeal_120x.jpg?v=10559929356198568856")','oatmeal-with-blue-thread': 'url("//bumpyroadsstudio.com/cdn/shop/files/OatmealBlue_120x.jpg?v=9410205688867235664")','river-swirls-on-light-blue': 'url("//bumpyroadsstudio.com/cdn/shop/files/RiverSwirlsLightBlue_120x.jpg?v=14557675628678391496")','river-swirls-on-mid-blue': 'url("//bumpyroadsstudio.com/cdn/shop/files/RiverSwirlsMidBlue_120x.jpg?v=16993722113364468301")','river-swirls-on-dark-blue': 'url("//bumpyroadsstudio.com/cdn/shop/files/RiverSwirlsDarkBlue_120x.jpg?v=15968633365992161726")','lilies-on-espresso': 'url("//bumpyroadsstudio.com/cdn/shop/files/Lillies_120x.jpg?v=14774293682092654428")','daisies-on-light-blue': 'url("//bumpyroadsstudio.com/cdn/shop/files/DaisiesLightBlue_120x.jpg?v=17924509832025805885")','river-rocks-on-tan': 'url("//bumpyroadsstudio.com/cdn/shop/files/RiverRocks_120x.jpg?v=6206347915360825736")','clotted-cream': 'url("//bumpyroadsstudio.com/cdn/shop/files/ClottedCream_120x.jpg?v=17943739918278909921")','latte': 'url("//bumpyroadsstudio.com/cdn/shop/files/Latte_120x.jpg?v=16325114859637708366")','sage': 'url("//bumpyroadsstudio.com/cdn/shop/files/Sage_120x.jpg?v=501823605478003370")','forest': 'url("//bumpyroadsstudio.com/cdn/shop/files/Forest_120x.jpg?v=392688445946216319")','storm-cloud': 'url("//bumpyroadsstudio.com/cdn/shop/files/StormCloud_120x.jpg?v=11276039749718607158")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
